import { createConfig, createFlowContext } from '@betterment/shared-components';
import { Outlet, useParams } from 'react-router-dom';
import * as Yup from 'yup';

export const PURPOSE_TYPES = ['EmergencyFund', 'Retirement', 'MajorPurchase'] as const;

export const selection = Yup.object({
  purposeType: Yup.string().oneOf(PURPOSE_TYPES).required(),
});

export const PURPOSE_SELECTION_FLOW_CONFIG = createConfig({
  selection: {
    schema: selection,
    dependencies: Yup.object({}),
  },
  assignment: {
    schema: Yup.object({}),
    dependencies: Yup.object({
      selection,
    }),
  },
});

export const { FlowProvider, useStep: usePurposeSelectionStep } = createFlowContext(PURPOSE_SELECTION_FLOW_CONFIG);

export const PurposeSelectionFlow = () => {
  const { flowId } = useParams<{ flowId: string }>();

  return (
    <FlowProvider flowId={flowId}>
      <Outlet />
    </FlowProvider>
  );
};
